import "./sub-heading.css"; // Import the CSS file
import { Button } from "antd";

interface HeadingProps {
  title?: string;
  buttonName?: string;
  onClickNavigate?: any;
  userDetails?: any;
  id?: string;
  currentPage?: string;
}
const SubHeading = ({
  title,
  buttonName,
  onClickNavigate,
  userDetails,
  id,
  currentPage
}: HeadingProps) => {
  return (
    <div id={`sub-heading-${id}`} className="table-title">
      <h4>{title}</h4>
        {buttonName &&
          <Button
            type="primary"
            onClick={onClickNavigate}
            className="data-heading-btn"
          >
            {buttonName}
          </Button>
        }
    </div>
  );
};

export default SubHeading;
